import { render, staticRenderFns } from "./demandAdd.vue?vue&type=template&id=5c4c9111"
import script from "./demandAdd.vue?vue&type=script&lang=js"
export * from "./demandAdd.vue?vue&type=script&lang=js"
import style0 from "./demandAdd.vue?vue&type=style&index=0&id=5c4c9111&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports